const { onlyAlphaNumeric } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyAlphaNumeric(zipCode);

exports.countryDefinition = {
  country: 'Swaziland',
  code: 'SZ',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  formFormat: [['company'], ['address'], ['address2'], ['city'], ['zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[A-Za-z]{1}[0-9]{3}$/),
      error: 'Must be 1 letter and 3 numbers like H100'
    }
  ]
};
